module.exports = __webpack_public_path__ + "static/media/SDFSA_7-317w.4b043f20.webp";